import { Navigate, Route, Routes } from "react-router-dom";

import { NoAccess, SubNav } from "@/app/Shell";
import { GATE, useSession } from "@/auth/session";
import { AuditLogPage } from "@/modules/security/AuditLogPage";

/** Security (OSE-14) — the operator surface over the device PKI.
 *
 *  SUPER ADMIN ONLY, and not by a check written here. `GATE_SECURITY` (600) is
 *  in `NEVER_FOR_CUSTOMERS`, so no plan and no company role can hold it;
 *  `capabilities_for` grants it to `super_admin` alone. Dattatray: *"Only super
 *  admin will have acces to this UI page!"*
 *
 *  THE MODULE GUARDS ITSELF, like Fleet and unlike the read-only modules. The
 *  rail is cosmetic, so a typed `/security/audit` would otherwise render the
 *  whole page and let the visitor learn the answer from a row of 403s. The
 *  server's `require_cap(GATE_SECURITY)` is still the enforcement; this is what
 *  stops the console asking.
 *
 *  ONE SUBPAGE TODAY, AND THE TAB ROW STAYS ANYWAY — the same correction
 *  Dattatray made on Fleet: *"In fleet becasuse there is one sub page: You have
 *  removed the sub page selection tab itself!"* A module that silently drops
 *  its tab row reads as a different kind of page, and the row is where the
 *  expiry dashboard (OSE-02) lands next.
 */
export function SecurityModule() {
  const { can } = useSession();
  if (!can(GATE.SECURITY)) return <NoAccess label="Security" />;
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav base="/security" tabs={[{ path: "audit", label: "Audit log" }]} />
      </div>
      <Routes>
        <Route path="audit" element={<AuditLogPage />} />
        <Route path="*" element={<Navigate replace to="/security/audit" />} />
      </Routes>
    </>
  );
}
